import { render, staticRenderFns } from "./ledger-accounts.vue?vue&type=template&id=1f77feaf&"
import script from "./ledger-accounts.ts?vue&type=script&lang=js&"
export * from "./ledger-accounts.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports